// src/sagas/storeSaga.js
import { call, put, takeLatest } from "redux-saga/effects";
import {
  FETCH_STORE_REQUEST,
  CREATE_STORE_ITEM_REQUEST,
  UPDATE_STORE_ITEM_REQUEST,
  DELETE_STORE_ITEM_REQUEST,
} from "../actions/types";
import {
  fetchStoreSuccess,
  fetchStoreFailure,
  createStoreItemSuccess,
  createStoreItemFailure,
  updateStoreItemSuccess,
  updateStoreItemFailure,
  deleteStoreItemSuccess,
  deleteStoreItemFailure,
} from "../actions/storeActions";
import { saveLibraryCardToApi, deleteLibraryCardFromApi } from "../apis/libraryCardApi";
import { fetchPublicStore } from "../apis/publicApi";
import { v4 as uuidv4 } from "uuid";
import { getTenantId, getOwnerTenantId } from "../utils/authUtils";

function* fetchStoreSaga(action) {
  try {
    const tenantId = action.payload?.tenantId || getOwnerTenantId();
    const cards = yield call(fetchPublicStore, { tenantId });
    const items = cards.map((card) => ({
      ...card,
      ...(typeof card.payload === "string" ? JSON.parse(card.payload) : card.payload),
    }));
    yield put(fetchStoreSuccess(items));
  } catch (err) {
    console.error("storeSaga - fetchStore error:", err);
    yield put(fetchStoreFailure(err.message));
  }
}

function* createStoreItemSaga(action) {
  try {
    const tenantId = getTenantId();
    const entityId = uuidv4();
    const input = {
      tenantId,
      entityType: "STORE_ITEM",
      entityId,
      payload: JSON.stringify({ entityId, ...action.payload }),
    };
    const result = yield call(saveLibraryCardToApi, input);
    if (!result?.success) throw new Error(result?.message || "Save failed");
    yield put(createStoreItemSuccess({ entityId, entityType: "STORE_ITEM", tenantId, ...action.payload }));
  } catch (err) {
    console.error("storeSaga - createStoreItem error:", err);
    yield put(createStoreItemFailure(err.message));
  }
}

function* updateStoreItemSaga(action) {
  try {
    const tenantId = getTenantId();
    const { entityId, entityType: _et, tenantId: _t, payload: _p, createdAt: _c, ...itemData } = action.payload;
    const input = {
      tenantId,
      entityType: "STORE_ITEM",
      entityId,
      payload: JSON.stringify({ entityId, ...itemData }),
    };
    const result = yield call(saveLibraryCardToApi, input);
    if (!result?.success) throw new Error(result?.message || "Save failed");
    yield put(updateStoreItemSuccess(action.payload));
  } catch (err) {
    console.error("storeSaga - updateStoreItem error:", err);
    yield put(updateStoreItemFailure(err.message));
  }
}

function* deleteStoreItemSaga(action) {
  try {
    const tenantId = getTenantId();
    const { entityId } = action.payload;
    yield call(deleteLibraryCardFromApi, { tenantId, entityType: "STORE_ITEM", entityId });
    yield put(deleteStoreItemSuccess(entityId));
  } catch (err) {
    console.error("storeSaga - deleteStoreItem error:", err);
    yield put(deleteStoreItemFailure(err.message));
  }
}

export default function* storeSaga() {
  yield takeLatest(FETCH_STORE_REQUEST, fetchStoreSaga);
  yield takeLatest(CREATE_STORE_ITEM_REQUEST, createStoreItemSaga);
  yield takeLatest(UPDATE_STORE_ITEM_REQUEST, updateStoreItemSaga);
  yield takeLatest(DELETE_STORE_ITEM_REQUEST, deleteStoreItemSaga);
}
